import { Injectable } from '@angular/core';
import {Headers, RequestOptions, URLSearchParams} from '@angular/http';
import {Booking} from '../shared/model/booking.entity';
import {GLOBAL} from '../shared/global';
import { Observable } from 'rxjs/Observable';
import { ApiService } from './api.service';
import { Subject } from 'rxjs/Subject';
import 'rxjs/add/operator/catch';
import 'rxjs/add/operator/debounceTime';
import 'rxjs/add/operator/distinctUntilChanged';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/switchMap';
import 'rxjs/add/operator/toPromise';
import 'rxjs/add/observable/throw';
import {Payments} from '../shared/model/payment.entity';

@Injectable()
export class BookingService extends ApiService {
    public token: string;
    bookings: Booking[] = [];
    notify = new Subject<any>();
    notifyObservable$ = this.notify.asObservable();
    /*
      While this method seems to have no significance, Most of the method below would fail, if DI fails.
      Also when running test cases, mocking backend needs to ensure the HTTP is in provider and injector
     */
    isValidHttp(): boolean {
        return (this.http !== undefined || this.http !== null);
    }
    /*
      The Api should be able to create different type of bookings.
    */
    createBooking(booking: Booking): Observable<Object> {

        let headers = new Headers({'Accept': 'application/json',
            'Content-Type': 'application/json'});
        let options = new RequestOptions({ headers: headers, params: {sub_org: 'ALL'} });
        let obj = { 'booking': booking.clean(booking.toJSON()) };

        return this.http.post(GLOBAL.BOOKING_API + '/' , JSON.stringify(obj), options)
            .map(this.extractData)
            .catch((err) => { return this.handleError(err); });
    }
    /*
      The Api should be used interpreter accept or reject or tentative
    */
    interpreterAction(bookingID: number, interpreter_ID: number , state: string): Observable<Object> {

        let headers = new Headers({'Accept': 'application/json',
            'Content-Type': 'application/json'});
        let options = new RequestOptions({ headers: headers, params: {sub_org: 'ALL'} });

        return this.http.put(GLOBAL.BOOKING_API + '/' + bookingID + '/interpreter/' +  interpreter_ID + '/' + state, options)
            .map(this.extractData)
            .catch((err) => { return this.handleError(err); });
    }
    /**
     * Accepts multiple bookings invites for interpreter
     */
    interpreterAcceptMultiple(interpreterId: number, bookingIds: number[]) {
      const headers = new Headers({Accept: 'application/json', 'Content-Type': 'application/json'});
      const options = new RequestOptions({headers: headers, params: {sub_org: 'ALL'}});

      return this.http
        .put(
          `${GLOBAL.BOOKING_API}/interpreter/${interpreterId}/accept_invites`,
          {booking_ids: bookingIds},
          options
        )
        .map(this.extractData)
        .catch((err) => {
          return this.handleError(err);
        });
    }
    /**
     * Rejects multiple bookings invites for interpreter
     */
    interpreterRejectMultiple(interpreterId: number, bookingIds: number[]) {
      const headers = new Headers({Accept: 'application/json', 'Content-Type': 'application/json'});
      const options = new RequestOptions({headers: headers, params: {sub_org: 'ALL'}});

      return this.http
        .put(
          `${GLOBAL.BOOKING_API}/interpreter/${interpreterId}/reject_invites`,
          {booking_ids: bookingIds},
          options
        )
        .map(this.extractData)
        .catch((err) => {
          return this.handleError(err);
        });
    }
    /*
      The Api should be used to reject interpreters
    */
    rejectInterpreters(bookingID: number, interpreters: Array<Object>, state: string): Observable<Object> {

        let headers = new Headers({'Accept': 'application/json',
            'Content-Type': 'application/json'});
        let options = new RequestOptions({ headers: headers, params: {sub_org: 'ALL'} });
        let obj = this.getParamsForDecline(bookingID, interpreters, state);

        return this.http.put(GLOBAL.BOOKING_API + '/' + bookingID + '/reject_interpreters' , JSON.stringify(obj), options)
            .map(this.extractData)
            .catch((err) => { return this.handleError(err); });
    }
    /*
      The Api should be used to invite interpreters
    */
    inviteInterpreters(bookingID: number, interpreters: Array<Object>, isAutoInvite: boolean): Observable<Object> {

        let headers = new Headers({'Accept': 'application/json',
            'Content-Type': 'application/json'});
        let options = new RequestOptions({ headers: headers, params: {sub_org: 'ALL'} });
        let obj = this.getParamsForInviteOrAssign(bookingID, interpreters, isAutoInvite);

        return this.http.post(GLOBAL.BOOKING_API + '/' + bookingID + '/invite_interpreters' , JSON.stringify(obj), options)
            .map(this.extractData)
            .catch((err) => { return this.handleError(err); });
    }
    /*
      The Api should be used to stop auto invite interpreters
    */
   stopInviteInterpreters(bookingID: number): Observable<Object> {

    let headers = new Headers({'Accept': 'application/json',
        'Content-Type': 'application/json'});
    let options = new RequestOptions({ headers: headers, params: {sub_org: 'ALL'} });

    return this.http.post(GLOBAL.BOOKING_API + '/' + bookingID + '/stop_auto_invite', options)
        .map(this.extractData)
        .catch((err) => { return this.handleError(err); });
   }

    private getParamsForInviteOrAssign(bookingID: number, interpreters: Array<Object>, isAutoInvite: boolean) {
        let invite_url = GLOBAL.BOOKING_JOB_INVITE + bookingID + '/job-detail';
        invite_url = invite_url.startsWith('http') === false ? 'http://' + invite_url : invite_url;
        let obj;
        if (isAutoInvite) {
            obj = {'invite_url': invite_url, 'interpreters': interpreters, 'auto_invitation': isAutoInvite};
        } else {
            obj = {'invite_url': invite_url, 'interpreters': interpreters};
        }
        return obj;
    }
    private getParamsForDecline(bookingID: number, interpreters: Array<Object>, state: string) {
        let obj;
        if (state) {
            obj = {'interpreters': interpreters, 'state': state};
        } else {
            obj = {'interpreters': interpreters};
        }
        return obj;
    }

    /*
     The Api should be used to re assign interpreters
   */
    reAssignInterpreter(bookingID: number, interpreters: Array<Object>): Observable<Object> {

        let headers = new Headers({'Accept': 'application/json',
            'Content-Type': 'application/json'});
        let options = new RequestOptions({ headers: headers, params: {sub_org: 'ALL'} });
        let obj = this.getParamsForInviteOrAssign(bookingID, interpreters, false);

        return this.http.put(GLOBAL.BOOKING_API + '/' + bookingID + '/assign_interpreters/' , JSON.stringify(obj), options)
            .map(this.extractData)
            .catch((err) => { return this.handleError(err); });
    }
    /*
     The Api should be used to re assign interpreters
   */
    unAssignInterpreter(bookingID: number, interpreter_id: number): Observable<Object> {

        let headers = new Headers({'Accept': 'application/json',
            'Content-Type': 'application/json'});
        let options = new RequestOptions({ headers: headers, params: {sub_org: 'ALL'} });

        return this.http.put(GLOBAL.BOOKING_API + '/' + bookingID +  '/interpreter/' + interpreter_id + '/unassign'  , options)
            .map(this.extractData)
            .catch((err) => { return this.handleError(err); });
    }
    /*
      The Api should be able to update already created bookings.
    */
    updateBooking(booking_id: string, booking: Booking): Observable<Object> {
        let headers = new Headers({'Accept': 'application/json',
            'Content-Type': 'application/json'});
        let options = new RequestOptions({ headers: headers, params: {sub_org: 'ALL'} });
        let obj = { 'booking': booking.toJSON() };
        return this.http.patch(GLOBAL.BOOKING_API + '/' + booking_id, JSON.stringify(obj), options)
            .catch((err) => { return this.handleError(err); });

    }

    /*
      The Api should be able to update transitioning of already requested bookings.
    */
    updateBookingByTransitioning(booking_id: string, next_state: string, update_all_linked_bookings?: boolean, cancellation_reason?: string): Observable<Object> {

        let headers = new Headers({'Accept': 'application/json',
            'Content-Type': 'application/json'});
        let options = new RequestOptions({ headers: headers, params: {sub_org: 'ALL'} });
        let obj = { 'booking': {'next_state': next_state, 'update_all_linked_bookings': update_all_linked_bookings, 'cancellation_reason': cancellation_reason} };
        return this.http.patch(GLOBAL.BOOKING_API + '/' + booking_id, JSON.stringify(obj), options)
            .catch((err) => { return this.handleError(err); });

    }

    /*
      The Api should be able to undo cancel by transitioning of already requested bookings.
    */
   undoCancelBookingByTransitioning(booking_id: string, next_state: string, cancellation_reason?: string): Observable<Object> {

    let headers = new Headers({'Accept': 'application/json',
        'Content-Type': 'application/json'});
    let options = new RequestOptions({ headers: headers, params: {sub_org: 'ALL'} });
    let obj = { 'booking': {'next_state': next_state, 'cancellation_reason': cancellation_reason} };
    return this.http.patch(GLOBAL.BOOKING_API + '/' + booking_id, JSON.stringify(obj), options)
        .catch((err) => { return this.handleError(err); });

}
    /*
      The Api should be able to fetch all the bookings.
    */
    fetchBookings(search?: URLSearchParams): Observable<Object> {
        let headers = new Headers({'Accept': 'application/json'});

        if (!search.has('sub_org')) {
          search.append('sub_org', 'ALL');
        }
        let options = new RequestOptions({ headers: headers, search: search });
        return this.http.get(GLOBAL.BOOKING_API, options)
            .map(this.extractData)
            .catch((err) => { return this.handleError(err); });
    }

    /*
      The Api should be able to fetch all the organisations.
    */
   fetchOrganisations(params = {}): Observable<Object> {
    let headers = new Headers({'Accept': 'application/json'});
    let options = new RequestOptions({ headers: headers, params: {sub_org: 'ALL', ...params} });
    return this.http.get(GLOBAL.ORGANISATION_API, options)
        .map(this.extractData)
        .catch((err) => { return this.handleError(err); });
   }

    /*
      The Api should be able to fetch all the bookings.
    */
    fetchPaginatedBookings(page: number , pageSize: string, search: URLSearchParams): Observable<Object> {
        let headers = new Headers({'Accept': 'application/json'});

        if (!search.has('sub_org')) {
          search.set('sub_org', 'ALL');
        }
        let options = new RequestOptions({
            headers: headers, search: search
        });
        return this.http.get(GLOBAL.BOOKING_API + '?page=' + page + '&per_page=' + pageSize, options)
            .map(this.extractData)
            .catch((err) => { return this.handleError(err); });
    }
    /*
      The Api should be get booking by its ID (The Id should be email)
    */
    getBooking(id: number): Observable<Object> {
        let headers = new Headers({'Accept': 'application/json'});
        let options = new RequestOptions({ headers: headers, params: {sub_org: 'ALL'} });

        return this.http
            .get(GLOBAL.BOOKING_API + '/' + id, options)
            .map(this.extractData)
            .catch((err) => { return this.handleError(err); });
    }

    getAvailableLinkIds(id: any): Observable<Object> {
        let headers = new Headers({'Accept': 'application/json'});
        let options = new RequestOptions({ headers: headers, params: {sub_org: 'ALL'} });

        return this.http
            .get([GLOBAL.BOOKING_API , id, 'link_ids'].join('/'), options)
            .map(this.extractData)
            .catch((err) => { return this.handleError(err); });
    }


    /*
      The Api should be get booking by its ID (The Id should be email)
    */
    deleteBooking(id: number): Observable<Object> {
        let headers = new Headers({'Accept': 'application/json',
            'Content-Type': 'application/json'});
        let options = new RequestOptions({ headers: headers, params: {sub_org: 'ALL'} });

        return this.http
            .delete(GLOBAL.BOOKING_API + '/' + id, options)
            .map(this.extractData)
            .catch((err) => { return Observable.throw(err); });

    }

    bulkUploadBookings(base64encodedUploadFile: String): Observable<Object> {

        let headers = new Headers({'Accept': 'application/json',
            'Content-Type': 'application/json'});
        let options = new RequestOptions({ headers: headers, params: {sub_org: 'ALL'} });
        let obj = {
            'bulk_upload_excel_file': base64encodedUploadFile,
            booking: {
                application_url: document.baseURI
            }
        };

        return this.http.post(GLOBAL.BOOKING_API + '/bulk_upload' , JSON.stringify(obj), options)
            .map(this.extractData)
            .catch((err) => { return this.handleError(err); });
    }
    public notifyOther(data: any) {
        if (data) {
          this.notify.next(data);
        }
      }

    nearbyBookings(booking_id: number, page?: number, search?: URLSearchParams): Observable<Object> {
        let headers = new Headers({'Accept': 'application/json'});

        if (!search.has('sub_org')) {
          search.append('sub_org', 'ALL');
        }
        let options = new RequestOptions({ headers: headers, search: search });

        return this.http
            .get(GLOBAL.BOOKING_API + '/' + booking_id + '/nearby_interpreters?page=' + page, options)
            .map(this.extractData)
            .catch((err) => { return this.handleError(err); });
    }

    getBookingPayments(booking_id: number): Observable<Object> {
        let headers = new Headers({'Accept': 'application/json'});
        let options = new RequestOptions({ headers: headers, params: {sub_org: 'ALL'} });

        return this.http
            .get(GLOBAL.BOOKING_API + '/' + booking_id + '/payments', options)
            .map(this.extractData)
            .catch((err) => { return this.handleError(err); });
    }

    updateBookingPayments(booking_id: number, payment: Payments, claim_notes: string, claim_payment): Observable<Object> {
        let headers = new Headers({'Accept': 'application/json',
        'Content-Type': 'application/json'});
        let options = new RequestOptions({ headers: headers, params: {sub_org: 'ALL'} });
        let obj = { 'payments': payment.createJSON(), 'claim_notes': claim_notes, 'claim_payment': claim_payment };

        return this.http.put(GLOBAL.BOOKING_API + '/' + booking_id + '/payments/group_update', JSON.stringify(obj), options)
            .map(this.extractData)
            .catch((err) => { return this.handleError(err); });
    }

    exportBookings(fromTo, params = {}): Observable<Object> {

        let headers = new Headers({'Accept': 'application/json',
            'Content-Type': 'application/json'});
        let options = new RequestOptions({ headers: headers, params: {sub_org: 'ALL', ...params} });

        return this.http.post(GLOBAL.USER_API_ENDPOINT + '/exports' , JSON.stringify(fromTo), options)
            .map(this.extractData)
            .catch((err) => { return this.handleError(err); });
    }

    checkClientAvailability(user: URLSearchParams) {
        let headers = new Headers({'Accept': 'application/json',
          'Content-Type': 'application/json'
        });
        user.set('sub_org', 'ALL');
        let options = new RequestOptions({ headers: headers, search: user});

        return this.http.get(GLOBAL.USER_API + '/find_client', options)
            .map(this.extractData)
            .catch((err) => { return this.handleError(err); });
    }
}



// WEBPACK FOOTER //
// ./src/app/api/booking.service.ts